/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "497b2db38b649470830248cb6bb6a7e1b02effe9";
